import { Injectable, inject } from "@angular/core";
import { PLATFORM_ADAPTER } from "../../core/platform/platform.adapter";
import { DatabaseService } from "../database/database.service";
import { SettingsService } from "../settings/settings.service";

@Injectable({
  providedIn: "root",
})
export class NotificationsService {
  private settings = inject(SettingsService);
  private database = inject(DatabaseService);
  private platform = inject(PLATFORM_ADAPTER);

  private tableEnsured = false;

  constructor() {
    console.log("Hello NotificationsProvider Provider");
  }

  private async ensureTable(): Promise<void> {
    if (this.tableEnsured) return;
    if (!this.platform.isNative) {
      this.tableEnsured = true;
      return;
    }
    try {
      await this.database.executeProcess(
        "ums",
        "CREATE TABLE IF NOT EXISTS `notifications` (`PK` INTEGER PRIMARY KEY AUTOINCREMENT, `id` INTEGER, `date` INTEGER, `seen` TEXT DEFAULT 'false', `read` TEXT DEFAULT 'false', `tags` TEXT, `header` TEXT, `body` TEXT, `origin` TEXT);"
      );
      this.tableEnsured = true;
    } catch (e) {
      console.warn("NotificationsSrv: could not ensure notifications table", e);
    }
  }

  public async getNotifications(): Promise<any> {
    if (!this.platform.isNative) return [];
    await this.ensureTable();
    const d = new Date();
    const t = d.getTime() - 24 * 60 * 60 * 1000;
    let registration = await this.settings.getSetting("registration");
    const data = await this.database.namedQuery("notificationsRecent", {
      cutoff: t,
      tagPattern: `%${registration};%`,
    });

    const notificationItems = [];
    if (data.length > 0) {
      for (let i = 0; i < data.length; i += 1) {
        const it = data[i];
        notificationItems.push({
          header: it.header,
          content: it.body,
          date: it.date,
          origin: it.origin,
          id: it.id,
          seen: it.seen,
        });
      }
    }
    return notificationItems;
  }

  public async getNumberOfNewNotifications(): Promise<any> {
    if (!this.platform.isNative) return 0;
    await this.ensureTable();
    let registration = await this.settings.getSetting("registration");

    const d = new Date();
    const t = d.getTime() - 24 * 60 * 60 * 1000;
    const data = await this.database.namedQuery("notificationsNewCount", {
      cutoff: t,
      tagPattern: `%${registration};%`,
    });
    return data.length;
  }

  public async setNotificationAsSeen(id: number): Promise<any> {
    if (!this.platform.isNative) return;
    await this.ensureTable();
    return new Promise((resolve, reject) => {
      const d = new Date();
      const t = d.getTime() - 24 * 60 * 60 * 1000;
      const query = [
        "UPDATE notifications SET `seen` = 'true' WHERE `id` =" + id + ";",
        "UPDATE notifications SET `read` = 'true', `seen` = 'true' WHERE `date` <= " + t.toString() + ";",
      ];
      this.database
        .sqlBatchProcess("ums", query)
        .then(() => {
          resolve(undefined);
        })
        .catch((err) => {
          console.error("err #fse");
          reject(err);
        });
    });
  }

  public async setAllNotificationAsSeen(): Promise<any> {
    if (!this.platform.isNative) return;
    await this.ensureTable();
    return new Promise((resolve, reject) => {
      const d = new Date();
      const t = d.getTime() - 24 * 60 * 60 * 1000;
      const query = [
        "UPDATE notifications SET `seen` = 'true';",
        "UPDATE notifications SET `read` = 'true' WHERE `date` <= " + t.toString() + ";",
      ];
      this.database
        .sqlBatchProcess("ums", query)
        .then(() => {
          resolve(undefined);
        })
        .catch((err) => {
          console.error("err #13sfsfss2");
          reject(err);
        });
    });
  }
}
